import { Component, ElementRef, HostListener } from '@angular/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { JudgeService } from '../../../../services/judge.service';
import { Judge, JudgeCategory, JudgeScore } from '../../../../model/judge';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';

@Component({
    selector: 'page-judge-scores',
    templateUrl: 'judge-scores.html'
})
export class JudgeScoresPage {
    rodeo: Rodeo;
    runId: number;
    selectedRodeoEvent: RodeoEvent;
    saving: boolean;
    
    hasDisqualification: any[];
    scores: any[];
    judgeConfig: { judges: Judge[], categories: JudgeCategory[], scoresHash?: { [key: number]: { totals: { [key: string]: number }, scores: JudgeScore[] } } };
    dataLoaded: boolean = false;

    constructor(private navParams: NavParams, private elementRef: ElementRef, private toast: ToastController, 
        private viewController: ViewController, private judgeService: JudgeService) {
        this.rodeo = navParams.get('rodeo');
        this.runId = navParams.get('runId');
        this.selectedRodeoEvent = navParams.get('selectedRodeoEvent');
        this.dataLoaded = false;
        this.getJudgeScores();
    }

    getJudgeScores() {
        this.scores = [];
        this.hasDisqualification = [];

        this.judgeService.getScoresForRun(this.runId, this.selectedRodeoEvent.id)
            .then(judgeConfig => {
                if (!this.scores[this.runId])
                    this.scores[this.runId] = [];

                if (!this.hasDisqualification[this.runId])
                    this.hasDisqualification[this.runId] = [];

                if (judgeConfig && judgeConfig.judges && judgeConfig.judges.length > 0) {
                    const scoreHash = {};

                    this.judgeConfig = judgeConfig;
                    this.judgeConfig.judges.forEach(judge => {
                        const judgeIndex = this.judgeConfig.judges.indexOf(judge);
                        const scoresHash = [];
                        this.judgeConfig.categories.forEach(category => {
                            if (!this.scores[this.runId][judgeIndex])
                                this.scores[this.runId][judgeIndex] = [];

                            if (!this.hasDisqualification[this.runId][judgeIndex])
                                this.hasDisqualification[this.runId][judgeIndex] = 0;

                            this.scores[this.runId][judgeIndex][category.id] = { score: 0 };
                        });

                        judge.scores.forEach(score => {
                            const category = this.judgeConfig.categories.find(x => x.category.trim() === score.category.trim());
                            if (!scoresHash[score.runId]) {
                                scoresHash[score.runId] = {
                                    total: score.score,
                                    scores: [score]
                                }
                            } else {
                                scoresHash[score.runId].total += score.score;
                                scoresHash[score.runId].scores.push(score);
                            }

                            if (!this.scores[score.runId])
                                this.scores[score.runId] = [];

                            if (!this.scores[score.runId][judgeIndex])
                                this.scores[score.runId][judgeIndex] = [];

                            this.scores[score.runId][judgeIndex][category.id] = score;

                            if (score.disqualify) {
                                this.hasDisqualification[this.runId][judgeIndex] = 1;
                                console.log("judgeIndex has DQ", judgeIndex);
                            }

                            // Second hash?
                            if (!scoreHash[score.runId]) {
                                scoreHash[score.runId] = {
                                    totals: {
                                        total: score.score,
                                    }
                                }
                            } else {
                                scoreHash[score.runId].totals.total += score.score;
                            }

                            if (scoreHash[score.runId].totals[score.category]) {
                                scoreHash[score.runId].totals[score.category] += score.score;
                            } else {
                                scoreHash[score.runId].totals[score.category] = score.score;
                            }
                        });

                        judge.scoresHash = scoresHash;
                    });

                    if (this.selectedRodeoEvent.averageJudgeTotalScores) {
                        Object.keys(scoreHash).forEach(runId => {
                            Object.keys(scoreHash[runId].totals).forEach(key => {
                                if (key == 'total') {
                                    scoreHash[runId].totals.total = scoreHash[runId].totals.total / this.judgeConfig.judges.length;
                                    console.log("scoreHash[runId].totals.total: ", scoreHash[runId].totals.total);
                                }
                            });
                        });
                    }
                    this.judgeConfig.scoresHash = scoreHash;
                    this.dataLoaded = true;
                } else {
                    this.judgeConfig = null;
                }
            });
    }

    getJudgeScore(judge: Judge, category: JudgeCategory, runId: number) {
        const judgeScores = judge.scoresHash ? judge.scoresHash[runId] : null;
        if (judgeScores) {
            const score = judgeScores.scores.find(x => x.category == category.category);
            return score ? score.score : 0;
        }
    }

    togglePenalty(runId, i, categoryId) {
        if (this.scores[runId][i][categoryId].score != 0)
            this.scores[runId][i][categoryId].score = 0;
        else
            this.scores[runId][i][categoryId].score = this.scores[runId][i][categoryId].max;
    }

    clearScores() {
        this.judgeService.clearScores(this.runId)
            .then(score => {
                this.dataLoaded = false;
                this.getJudgeScores();
                this.toast.create({
                    message: 'All Scores Cleared!',
                    duration: 2500,
                    position: 'bottom'
                }).present();
            })
            .catch(err => {
                this.toast.create({
                    message: 'Could not clear scores.',
                    duration: 2500,
                    position: 'bottom'
                }).present();
            })
    }

    save() {
        if (this.saving)
            return;

        this.saving = true;

        var scoresToSave = [];

        this.judgeConfig.judges.forEach(judge => {
            const judgeIndex = this.judgeConfig.judges.indexOf(judge);
            this.judgeConfig.categories.forEach(category => {
                if (!this.scores[this.runId] || !this.scores[this.runId][judgeIndex])
                    return;

                scoresToSave.push({
                    id: this.scores[this.runId][judgeIndex][category.id].id,
                    category: category.category,
                    judgeId: judge.id,
                    rodeoEventId: this.selectedRodeoEvent.id,
                    runId: this.runId,
                    score: this.scores[this.runId][judgeIndex][category.id].score
                });
            });
        });

        this.judgeService.saveScores(scoresToSave)
            .then(score => {
                this.saving = false;
                this.toast.create({
                    message: 'Scores saved!',
                    duration: 2500,
                    position: 'bottom'
                }).present();
                this.viewController.dismiss();
            })
            .catch(err => {
                this.saving = false;
                this.toast.create({
                    message: 'Could not save scores.',
                    duration: 2500,
                    position: 'bottom'
                }).present();
                this.viewController.dismiss();
            })
    }

    cancel() {
        this.viewController.dismiss();
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (this.elementRef.nativeElement.hidden)
            return;

        if (ev.key === "Enter") {
            this.save();
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/scoring/judge-scores.ts